import { __spreadArrays } from "tslib";
import * as React from 'react';
export var ProgressBar = function (_a) {
    var pageTitles = _a.pageTitles, currentStep = _a.currentStep;
    return (React.createElement("div", { className: "progress-bar" }, pageTitles.reduce(function (acc, value, index) { return __spreadArrays(acc, [
        React.createElement("button", { type: "button", className: "step" + (currentStep === index ? ' active' : '') + (currentStep > index ? ' complete' : ''), key: value },
            React.createElement("div", { className: "divider" },
                React.createElement("div", { className: "fill" })),
            React.createElement("span", { className: "title" }, value)),
    ]); }, [])));
};
//# sourceMappingURL=ProgressBar.js.map